import { TransformBoolean } from '../../../shared/decorators/transform-boolean.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { PercentageDepositRoundingModeEnum } from '../enums/percentage-deposit-rounding-mode.enum';

export class TenantSettingsReservationPercentageDepositRoundingDto {
  @TransformBoolean()
  isEnabled?: boolean;

  @TransformFloat()
  increment?: number;

  mode?: PercentageDepositRoundingModeEnum;
}
